import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";

export default function Impact(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		setReady(false);
		// initializations...
		setReady(true);
	}

	useEffect(() => {
		init();
	}, []);

	

	if (ready) {
		return (
			<div 
				className="MainBodySection bg-surface"
				style={{
					paddingTop: "50px",
					paddingBottom: "50px"
				}}
			>
				<div 
					className="container"
				>
					<div className="row g-3">

						<div className="col-md-12">
							<h6
								className="main-section-title"
							>
								Our Impact
							</h6>
							<h5 className="text-muted font-bold mb-5">
								Tanzania Children Hope Innovations (TCHI) transforms lives through community-driven support, empowering children, families, and vulnerable groups to achieve education, health, and economic well-being.
							</h5>
						</div>	

						<div className="col-md-12">

							<div className="row g-3">

								<div className="col-md-4">
									<div className="bg-secondary rounded p-3 h-100">
										<div className="text-center">
											<h1 className="font-bold pt-3" style={{ fontSize:"48px" }}>633+</h1>
											<h6>MVCs Identified</h6>
										</div>
										<div className="lh-lg mt-3">
											<hr />
											Within TCHI’s first year, 633 children across five wards in Mbeya were identified as Most Vulnerable Children (MVCs), ensuring they receive direct community support.
										</div>
									</div>
								</div>

								<div className="col-md-4">
									<div className="bg-secondary rounded p-3 h-100">
										<div className="text-center">
											<h1 className="font-bold pt-3" style={{ fontSize:"48px" }}>20+</h1>
											<h6>Active Community Sponsors</h6>
										</div>
										<div className="lh-lg mt-3">
											<hr />
											Over 20 local sponsors have committed to supporting multiple children, demonstrating strong community engagement and the effectiveness of TCHI’s locally driven model.
										</div>
									</div>
								</div>

								<div className="col-md-4">
									<div className="bg-secondary rounded p-3 h-100">
										<div className="text-center">
											<h1 className="font-bold pt-3" style={{ fontSize:"48px" }}>100+</h1>
											<h6>Local Sponsors Targeted</h6>
										</div>
										<div className="lh-lg mt-3">
											<hr />
											Through ongoing community sensitization and CHW training, TCHI aims to mobilize over 100 sponsors across remaining wards, scaling support for vulnerable children and families sustainably.
										</div>
									</div>
								</div>

							</div>
							
						</div>

						<div className="col-md-12 text-center">
							<button 
								className="btn btn-secondary btn-rounded my-5 px-5"
								onClick={() => {
									appContext.navTo({
										item: "about_us",
									});
								}}
							>
								Learn More...
							</button>
						</div>

					</div>
				</div>
			</div>	
		);
	} else {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}
}
